const normalizePriceVariant = (variant = {}, index = 0) => ({
  id: variant.id || `variant-${index + 1}`,
  name: variant.name || "",
  price: variant.price ?? 0
});

const getPriceVariants = ({ variants, fallbackPrice }) => {
  if (Array.isArray(variants) && variants.length) {
    return variants.map(normalizePriceVariant);
  }
  return [
    {
      id: "variant-1",
      name: "",
      price: fallbackPrice || 0
    }
  ];
};

export const getLeadServicePlusPriceVariants = (funnel = {}) =>
  getPriceVariants({
    variants: funnel.priceVariantsForLeadAgent,
    fallbackPrice: funnel?.pricePerInvoiceUnitForLeadAgent
  });

export const getLeadServicePlusFixedPriceVariants = (funnel = {}) =>
  getPriceVariants({
    variants: funnel.fixedPriceVariantsForLeadAgent,
    fallbackPrice: funnel?.fixedPricePerInvoiceUnitForLeadAgent
  });

export const getPrimaryPriceVariantPrice = (funnel = {}) =>
  getLeadServicePlusPriceVariants(funnel)[0]?.price || 0;
